import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import DepartmentTopBar from "./DepartmentTopBar.jsx";
import client from "../api/client";
import "../styles/department-base.css";

const DEPARTMENT_LABELS = {
  legal: "Legal Department",
  medical: "Medical Department",
  education: "Education Department",
  emergency: "Emergency Support",
};

export default function DepartmentLayout() {
  const navigate = useNavigate();
  const [deptUser] = useState(() => {
    try {
      const stored = localStorage.getItem("deptUser");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    const interceptorId = client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          const isDeptRoute = window.location.pathname.startsWith("/departments");
          const isAuthRoute = error.config?.url?.includes("/auth/");
          if (isDeptRoute && !isAuthRoute) {
            localStorage.removeItem("deptToken");
            localStorage.removeItem("deptUser");
            navigate("/departments/login", { replace: true });
          }
        }
        return Promise.reject(error);
      }
    );
    return () => {
      client.interceptors.response.eject(interceptorId);
    };
  }, [navigate]);

  const departmentLabel = deptUser?.department
    ? DEPARTMENT_LABELS[deptUser.department] || deptUser.department
    : "Department";

  const handleLogout = () => {
    try {
      client.post("/api/department/auth/logout").catch(() => {});
    } catch {
      // ignore
    }
    localStorage.removeItem("deptToken");
    localStorage.removeItem("deptUser");
    navigate("/departments/login", { replace: true });
  };

  return (
    <div className="dept-layout">
      <div className="dept-layout__main">
        <DepartmentTopBar
          deptUser={deptUser}
          departmentLabel={departmentLabel}
          onLogout={handleLogout}
        />
        <div className="dept-layout__content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
